/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 * @flow
 */

import Container from 'components/Container'
import PropTypes from 'prop-types'
import FooterNav from './FooterNav'
import MetaTitle from 'templates/components/MetaTitle'
import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { colors, media } from 'theme'
import { sectionListDocs } from 'utils/sectionList'

// marketing: allMarkdownRemark(
//   filter: {fileAbsolutePath: {regex: "//home/marketing//"}}
//   sort: {fields: [frontmatter___order], order: ASC}
// ) {
//   edges {
//     node {
//       frontmatter {
//         title
//       }
//       html
//     }
//   }
// }

const footerMetadataQuery = graphql`
  query FooterMetadata {
    site {
      siteMetadata {
        siteVersion
      }
    }
  }
`

import ossLogoPng from 'images/oss_logo.png'

const Footer = ({
  layoutHasSidebar = false
}: {
  layoutHasSidebar: boolean
}) => (
  <footer
    css={{
      backgroundColor: colors.darker,
      color: colors.white,
      paddingTop: 10,
      paddingBottom: 50,

      [media.size('sidebarFixed')]: {
        paddingTop: 40
      }
    }}
  >
    <Container>
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',

          [media.between('small', 'medium')]: {
            paddingRight: layoutHasSidebar ? 240 : null
          },

          [media.between('large', 'largerSidebar')]: {
            paddingRight: layoutHasSidebar ? 280 : null
          },
          [media.between('largerSidebar', 'sidebarFixed', true)]: {
            paddingRight: layoutHasSidebar ? 380 : null
          }
        }}
      >
        <div
          css={{
            flexWrap: 'wrap',
            display: 'flex',

            [media.lessThan('large')]: {
              width: '100%'
            },
            [media.greaterThan('xlarge')]: {
              width: 'calc(100% / 1)',
            }
          }}
        >
          <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <StaticQuery
              query={footerMetadataQuery}
              render={data => (
                <MetaTitle onDark={true}>v{data.site.siteMetadata.siteVersion}</MetaTitle>
              )}
            />
          </FooterNav>

          {/* <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <MetaTitle onDark={true}>Docs</MetaTitle>
            {sectionListDocs.map(section => {
              const defaultItem = section.items[0];
              return (
                <FooterLink
                  to={`/docs/${defaultItem.id}.html`}
                  key={section.title}>
                  {section.title}
                </FooterLink>
              );
            })}
          </FooterNav> */}
          {/* <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <MetaTitle onDark={true}>Community</MetaTitle>
            {sectionListCommunity.map(section => (
              <FooterLink
                to={`/community/${section.items[0].id}.html`}
                key={section.title}>
                {section.title}
              </FooterLink>
            ))}
          </FooterNav> */}
        </div>
        <section
          css={{
            paddingTop: 40,
            display: 'block !important', // Override 'Installation' <style> specifics

            [media.greaterThan('xlarge')]: {
              width: 'calc(100% / 3)',
              order: -1
            },
            [media.greaterThan('large')]: {
              order: -1,
              width: layoutHasSidebar ? null : 'calc(100% / 3)'
            },
            [media.lessThan('large')]: {
              textAlign: 'center',
              width: '100%',
              paddingTop: 40
            }
          }}
        />
      </div>
    </Container>
  </footer>
)

Footer.propTypes = {
  data: PropTypes.shape({
    meto: PropTypes.object.isRequired
  }).isRequired
}

export default Footer
